export const LabPipelineColumn = {
  flow: 'y',
  gap: 'Z',
  flex: '1',
  minWidth: 'G3',
  height: '100%',
  background: 'inkSurface',
  round: 'A',
  padding: 'Z',
  overflow: 'auto',
  ColumnHeader: {
    flow: 'x',
    order: -1,
    align: 'center space-between',
    padding: 'Y Z',
    marginBottom: 'Y',
    Title: {
      text: (el, s) => s.title || 'Column',
      fontSize: 'Z',
      fontWeight: '700',
      color: 'inkText'
    },
    Count: {
      tag: 'span',
      text: (el, s) => s.count || '0',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Y',
      round: 'B',
      background: 'inkMid',
      color: 'inkMuted'
    }
  },
  Cards: {
    flow: 'y',
    gap: 'Y',
    childExtends: 'LabCaseCard'
  }
}

export const LabPipeline = {
  flow: 'x',
  align: 'stretch start',
  gap: 'Z',
  width: '100%',
  overflow: 'auto',
  Submitted: {
    extends: 'LabPipelineColumn',
    state: { title: 'Impression Sent', count: '3' }
  },
  Fabrication: {
    extends: 'LabPipelineColumn',
    state: { title: 'In Fabrication', count: '2' }
  },
  Quality: {
    extends: 'LabPipelineColumn',
    state: { title: 'Quality Check', count: '1' }
  },
  TryIn: {
    extends: 'LabPipelineColumn',
    state: { title: 'Try-in Scheduled', count: '1' }
  },
  Ready: {
    extends: 'LabPipelineColumn',
    state: { title: 'Ready for Pickup', count: '1' }
  }
}
